import React from "react";
import DashboardCard from "../../components/DashboardCard/DashboardCard";
import "./Dashboard.scss";

const Dashboard = () => {
  const cards = [
    {
      bg: "#F8EFFF",
      heading: "Completed Orders",
      value: 1211,
      percentage: "100%",
    },
    {
      bg: "#FFF7E4",
      heading: "Pending Orders",
      value: 1211,
      percentage: "100%",
    },
    {
      bg: "#E3F5FF",
      heading: "Total Products Count",
      value: 1211,
      percentage: "100%",
    },
    {
      bg: "#FFE8EB",
      heading: "Total Categories Count",
      value: 1211,
      percentage: "100%",
    },
    {
      bg: "#E6EEFF",
      heading: "New Users",
      value: 342,
      percentage: "10% increase",
    },
    {
      bg: "#FFEFD5",
      heading: "Total Revenue",
      value: "$34,000",
      percentage: "15% increase",
    },
    {
      bg: "#FFE4E1",
      heading: "Refund Requests",
      value: 23,
      percentage: "2% decrease",
    },
    {
      bg: "#FFFACD",
      heading: "Low Stock Products",
      value: 57,
      percentage: "Restock needed",
    },
    {
      bg: "#E0FFFF",
      heading: "Site Traffic",
      value: 5123,
      percentage: "8% increase",
    },
  ];

  return (
    <div className="dashboard">
      <div className="dashboard_section">
        <div className="dashboard_section_cards">
          {cards?.map((card, index) => {
            return <DashboardCard card={card} key={index} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
